import React from 'react';
import {PageCover, SectionWithText,OurValue, BrandStory, History,BusinessArea,BrandIdentity, Footer, Map, Media, Members } from 'components/section';

const About = () => {

  return (
    <div className="About padding-cover">

      <PageCover 
        url="about"
        title = "발달장애인 꿈의 직장, 동구밭" 
        text = "발달장애인 사원인 ‘가꿈지기’와 함께 품질과 가치를 모두 잡은 제품을 생산하고 있습니다."
      />
      <SectionWithText />
      <OurValue />
      <BrandStory />
      <History />
      <BusinessArea className="bgColor-lightGrey"/>
      <BrandIdentity />
      <Media className="bgColor-lightGrey"  />
      <Members />
      <Map type ="withText" className="bgColor-lightGrey"/>
      <Footer />


    </div>
  );
}

export default About;